import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BASE_URL } from '../config/constants';
function Question() {
	const { t } = useTranslation();
	const [formData, setFormData] = useState({
		fullName: '',
		phoneNumber: '',
		email: '',
		subject: '',
		message: '',
	});

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const [success, setSuccess] = useState('');

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError('');
		setSuccess('');
		const baseUrl = BASE_URL;
		try {
			const response = await fetch(`${baseUrl}/api/v1/message`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(formData),
			});

			if (response.ok) {
				setSuccess('Message sent successfully!');
			} else {
				const data = await response.json();
				console.log(data);
				setError('Something went wrong!');
			}
		} catch (err) {
			setError('Failed to send message.');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className='card bg-white shadow-lg border-t-secondary border-t-4 border-t-solid flex flex-col gap-1 py-8 px-4 mb-6 md:w-1/2 relative top-[-75px]'>
			<h3 className='text-main text-2xl font-semibold'>{t('requestQuote')}</h3>
			<p className='text-textColor text-sm mb-10'>{t('quoteDescription')}</p>
			<form
				onSubmit={handleSubmit}
				className='grid grid-cols-1 md:grid-cols-2 gap-6'>
				{[
					{
						name: t('fullName'),
						placeholder: t('fullName'),
					},
					{
						name: t('phoneNumber'),
						placeholder: '+2 01021589478',
						type: 'tel',
					},
					{
						name: t('emailAddress'),
						placeholder: t('emailAddress'),
						type: 'email',
					},
					{
						name: t('contactUs'),
						placeholder: t('contactUs'),
					},
				].map((input, index) => (
					<input
						key={index}
						type={input.type || 'text'}
						name={input.name}
						placeholder={input.placeholder}
						required
						value={formData[input.name]}
						onChange={handleInputChange}
						className='outline-none p-3 border-2 border-solid border-[#cedbea] rounded-md'
					/>
				))}
				<textarea
					name='message'
					placeholder={t('yourMessage')}
					required
					value={formData.message}
					onChange={handleInputChange}
					className='outline-none p-3 border-2 border-solid border-[#cedbea] rounded-md md:col-span-2'
				/>

				<button
					type='submit'
					className={`px-5 py-3 rounded w-fit md:justify-self-start ${
						loading ? 'bg-gray-400' : 'bg-secondary text-white'
					}`}
					disabled={loading}>
					{loading ? 'Sending...' : t('sendMessage')}
				</button>

				{success && <p className='text-green-600 md:col-span-2'>{success}</p>}
				{error && <p className='text-red-600 md:col-span-2'>{error}</p>}
			</form>
		</div>
	);
}

export default Question;
